import React from 'react';
import useSWR from 'swr';
import { Box, Flex, SkeletonText, Text } from '@chakra-ui/react';
import { fetchData } from '../../services/fetch';
import StatusTag from './StatusTag';

const HISTORY_ENDPOINTS = {
 certificate: (id) => `certificate-status-control/${id}/history`,
 diagnostic: (id) => `diagnostic-status-control/${id}/history`,
};

function formatDateTime(value) {
 if (!value) return '';
 try {
  return new Date(value).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
 } catch {
  return '';
 }
}

// "A linha dos status": os controles de certificado e diagnóstico já guardam
// histórico completo (certificate_status_history / diagnostic_status_history),
// mas nenhuma tela mostrava. Timeline vertical simples, mesmo componente pros
// dois (o shape do histórico é idêntico nos dois backends).
export default function StatusHistoryTimeline({ kind, controlId }) {
 const endpoint = controlId ? HISTORY_ENDPOINTS[kind]?.(controlId) : null;
 const { data: history, isLoading } = useSWR(endpoint, fetchData);

 if (!controlId) return null;
 if (isLoading) return <SkeletonText noOfLines={3} spacing='3' />;

 if (!history?.length) {
  return (
   <Text fontSize='sm' color='#9CA0A6'>
    Nenhuma alteração de status registrada ainda.
   </Text>
  );
 }

 return (
  <Flex direction='column'>
   {history.map((entry, index) => (
    <Flex key={entry.id ?? index} gap='12px' align='flex-start'>
     <Flex direction='column' align='center' w='10px' flexShrink={0}>
      <Box w='8px' h='8px' borderRadius='full' bg='#0073BB' mt='6px' />
      {index < history.length - 1 && <Box w='1px' flex='1' bg='#DEE5E4' minH='20px' />}
     </Flex>
     <Box pb='16px' flex='1'>
      <Flex align='center' gap='8px' flexWrap='wrap' mb='4px'>
       <StatusTag status={entry.status} />
       <Text fontSize='xs' color='#9CA0A6'>
        {formatDateTime(entry.createdAt)}
       </Text>
      </Flex>
      {entry.motive && (
       <Text fontSize='sm' color='#5C6066'>
        {entry.motive}
       </Text>
      )}
      {entry.role && (
       <Text fontSize='xs' color='#9CA0A6' mt='2px'>
        por {entry.role}
       </Text>
      )}
     </Box>
    </Flex>
   ))}
  </Flex>
 );
}
